export default __webpack_public_path__ + "static/media/3089.e5bb304f.jpg";